var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { KeychainKeyTypesLC } from '@interfaces/keychain.interface';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setSuccessMessage } from '@popup/multichain/actions/message.actions';
import { VestingRoutesUtils } from '@popup/steem/utils/vesting-routes.utils';
import React from 'react';
import { connect } from 'react-redux';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
const VestingRouteItem = ({ account, nextCarouselSlide, isLast, setSuccessMessage, clearDisplayWrongVestingRoutes, accounts, addToLoadingList, removeFromLoadingList, differences, }) => {
    const renderVestingItemDetails = (vestingRoute, vestingRouteType) => {
        return (React.createElement("div", { key: `vesting-item-details-${vestingRoute.toAccount}-${vestingRouteType}-${vestingRoute.percent}`, className: `vesting-item-details-container ${vestingRouteType}` },
            React.createElement("div", { className: "title" },
                getMessage('popup_html_vesting_route_item_details_from_title'),
                `@${vestingRoute.fromAccount}`),
            React.createElement("div", { className: "title" },
                getMessage('popup_html_vesting_route_item_details_to_title'),
                `@${vestingRoute.toAccount}`),
            React.createElement("div", { className: "title" },
                getMessage('popup_html_vesting_route_item_details_percent_title'),
                vestingRoute.percent / 100),
            React.createElement("div", { className: "title" },
                getMessage('popup_html_vesting_route_item_details_autovest_title'),
                vestingRoute.autoVest.toString())));
    };
    const renderNone = () => {
        return (React.createElement("div", { key: `vesting-item-details-none`, className: `vesting-item-details-container ` },
            React.createElement("div", { className: "title" }, getMessage('popup_html_vesting_route_item_details_non_existent_label'))));
    };
    const skipAndSave = (differences, account) => __awaiter(void 0, void 0, void 0, function* () {
        yield VestingRoutesUtils.skipAccountRoutes(differences, account);
        checkForNextSlideOrHidePopup();
    });
    const checkForNextSlideOrHidePopup = () => {
        if (!isLast)
            return nextCarouselSlide();
        setSuccessMessage('popup_html_vesting_routes_handled_successfully');
        clearDisplayWrongVestingRoutes();
    };
    const revert = (differences, account) => __awaiter(void 0, void 0, void 0, function* () {
        addToLoadingList('html_popup_revert_vesting_route_operation');
        yield VestingRoutesUtils.revertAccountRoutes(accounts, differences, account);
        removeFromLoadingList('html_popup_revert_vesting_route_operation');
        checkForNextSlideOrHidePopup();
    });
    return (React.createElement("div", { className: `carousel-item`, key: `${account}-vesting-routes` },
        React.createElement("div", { className: "carousel-item-container" },
            React.createElement("div", { className: "account-title" },
                getMessage('popup_html_vesting_route_account_item_label') + ': @',
                account),
            React.createElement("div", { className: "vesting-routes-titles-container" },
                React.createElement("div", { className: "vesting-route-title old-route" }, getMessage('popup_html_vesting_route_account_item_old_route_title')),
                React.createElement("div", { className: "vesting-route-title new-route" }, getMessage('popup_html_vesting_route_account_item_new_route_title'))),
            React.createElement("div", { className: "vesting-item-list-container", key: `${account}-vesting-item-list-container` }, differences.map(({ oldRoute, newRoute }) => {
                var _a;
                const id = (_a = oldRoute === null || oldRoute === void 0 ? void 0 : oldRoute.toAccount) !== null && _a !== void 0 ? _a : newRoute === null || newRoute === void 0 ? void 0 : newRoute.toAccount;
                return (React.createElement("div", { key: `vesting-route-card-item-current-${id}`, className: "vesting-route-card-item" },
                    oldRoute
                        ? renderVestingItemDetails(oldRoute, 'old')
                        : renderNone(),
                    newRoute
                        ? renderVestingItemDetails(newRoute, 'new')
                        : renderNone()));
            })),
            React.createElement("div", { className: "vesting-action-buttons-container" },
                React.createElement(ButtonComponent, { dataTestId: "button-skip-vesting-routes", type: ButtonType.ALTERNATIVE, label: 'popup_html_vesting_route_account_item_button_skip_label', onClick: () => skipAndSave(differences, account), additionalClass: "vesting-action-button small-font" }),
                React.createElement(OperationButtonComponent, { dataTestId: "button-revert-vesting-routes", requiredKey: KeychainKeyTypesLC.active, onClick: () => revert(differences, account), label: 'popup_html_vesting_route_account_item_button_revert_label', additionalClass: 'vesting-action-button small-font' })))));
};
const mapStateToProps = (state) => {
    return {
        accounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    setSuccessMessage,
    addToLoadingList,
    removeFromLoadingList,
});
export const VestinRouteItemComponent = connector(VestingRouteItem);
